// Following conditions apply, if story is defined and is not accessType 'public'
// isFreeLimit() true means free limit not reached or has active subscription, so open story
// isFreeLimit() false means free limit reached; block the story
// isFreeLimit() null means not loggged in; block the story
// import useWhiteListedIP from "../../hook/useWhiteListedIp";
// isFreeLimit() null means not loggged in; block the story

export function isFreeLimit(checkUser, activeProducts, listed, visitCounts, articlesLimit, isVisitedSlug) {
    if (!listed) {
      if (checkUser && !activeProducts) {
        if (isVisitedSlug) {
          return true;
        }
        if (visitCounts < articlesLimit) {
          return true;
        } else {
          return false;
        }
      } else if (!checkUser || !activeProducts) {
        return null;
      } else if (checkUser && activeProducts) {
        return true;
      }
    } else if (listed) {
      return true;
    }

}
/** ********** function to invoke postUserVisitData */
export function postUserVisit(checkUser, activeProducts, visitCounts, articlesLimit, isVisitedSlug) {
  if (checkUser && !isVisitedSlug) {
    if (activeProducts) {
      return true;
    } else {
      if (visitCounts < articlesLimit) {
        return true;
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
}
